import {
  IAgencyCostImperial,
  IAgencyCostLineItemImperial,
  IAgencyCostLineItemMetric,
  IAgencyCostMetric,
  MainlineOptions,
} from '@/modules/agencyCost/interfaces/agencyCost';
import { ImperialUnits, MetricUnits } from '@/lib/unitConversion/unitConversionFactors';
import { UnitSystem } from '@/interfaces/units';
import convert from 'convert-units';


export const getLineItemWidth = function (L: IAgencyCostLineItemImperial | IAgencyCostLineItemMetric,
                                          scenario: IAgencyCostImperial | IAgencyCostMetric) {
  let width = null;

  if (scenario.unitSystem === UnitSystem.Imperial) {
    // console.log(scenario.outsideShoulderWidth_ft, scenario.insideShoulderWidth_ft, scenario.laneWidth_ft, L.mainline === MainlineOptions.MAINLINE)
    switch (L.mainline) {
      case MainlineOptions.MAINLINE:
        width = scenario.laneWidth_ft;
        break;
      case MainlineOptions.SHOULDER:
        width = scenario.outsideShoulderWidth_ft + scenario.insideShoulderWidth_ft;
        break;
      case MainlineOptions.BOTH:
        width = scenario.outsideShoulderWidth_ft + scenario.insideShoulderWidth_ft + scenario.laneWidth_ft;
        break;
    }
  } else {
    switch (L.mainline) {
      case MainlineOptions.MAINLINE:
        width = scenario.laneWidth_m;
        break;
      case MainlineOptions.SHOULDER:
        width = scenario.outsideShoulderWidth_m + scenario.insideShoulderWidth_m;
        break;
      case MainlineOptions.BOTH:
        width = scenario.outsideShoulderWidth_m + scenario.insideShoulderWidth_m + scenario.laneWidth_m;
        break;
    }
  }

  return width;
};

export const getQuantityImperial = function (L: IAgencyCostLineItemImperial,
                                             scenario: IAgencyCostImperial): number {
  let quantity = 0;

  // console.log(Boolean(L.thickness_in), scenario.unitSystem === UnitSystem.Imperial, L.units)

  if (L.thickness_in && L.units === ImperialUnits.MASS_SHTN) {
    // Quantity is in tons of mat'l, calculated from thickness and area
    // Get volume in yd3
    const width_ft = getLineItemWidth(L, scenario) || 0;
    const area_ft2 = width_ft * convert(scenario.totalLength_mi).from('mi').to('ft');
    const volume_ft3 = area_ft2 * (L.thickness_in / 12);
    quantity = convert(volume_ft3 * (L.density_lbPerFt3 || 0)).from('lb').to('t');
  } else if (L.units === ImperialUnits.AREA_YD2) {
    // console.log('area');

    // Quantity is in square yards
    const width_ft = getLineItemWidth(L, scenario) || 0;
    const length_ft = convert(scenario.totalLength_mi).from('mi').to('ft');
    quantity = (width_ft / 3) * (length_ft / 3);
  } else if (L.units === ImperialUnits.VOLUME_YD2IN) {
    const width_ft = getLineItemWidth(L, scenario) || 0;
    const length_ft = convert(scenario.totalLength_mi).from('mi').to('ft');
    const thickness_in = L.thickness_in || 0;
    quantity = (width_ft / 3) * (length_ft / 3) * thickness_in;
  } else if (L.fromDefault === false) {
    console.log('notfromdefault');
    quantity = L.quantity || 0;
  } else {
    quantity = L.quantity || 0;
  }


  // return Number(quantity.toFixed(2));
  return quantity;
};

export const getQuantityMetric = function (L: IAgencyCostLineItemMetric,
                                           scenario: IAgencyCostMetric): number {
  let quantity = 0;

  if (L.thickness_cm && L.units === MetricUnits.MASS_MTON) {
    // Get volume
    const width_m = getLineItemWidth(L, scenario) || 0;
    const area_m2 = width_m * convert(scenario.totalLength_km).from('km').to('m');
    const volume_m3 = area_m2 * convert(L.thickness_cm).from('cm').to('m');

    // Quantity is in short-tons of mat'l
    quantity = convert(volume_m3 * (L.density_kgPerM3 || 0)).from('kg').to('mt');
  } else if (L.units === MetricUnits.AREA_M2) {
    // Get area
    const width_m = getLineItemWidth(L, scenario) || 0;
    const length_m = convert(scenario.totalLength_km).from('km').to('m');
    quantity = (width_m) * (length_m);
  } else if (L.units === MetricUnits.VOLUME_M2CM) {
    const width_m = getLineItemWidth(L, scenario) || 0;
    const length_m = convert(scenario.totalLength_km).from('km').to('m');
    const thickness_cm = L.thickness_cm || 0;
    quantity = (width_m) * (length_m) * thickness_cm;
  } else if (L.fromDefault === false) {
    quantity = L.quantity || 0;
  } else {
    quantity = L.quantity || 0;
  }

  return quantity; // Number(quantity.toFixed(2));
};


export const getLineItemCost = function (L: IAgencyCostLineItemImperial | IAgencyCostLineItemMetric): number {
  return (L.quantity || 0) * (L.unitCost || 0);
};

export const getLineItemNpv = function (L: IAgencyCostLineItemImperial | IAgencyCostLineItemMetric,
                                        discountRatePct: number,
                                        yearsAfterStart: number): number {
  const baseCost = getLineItemCost(L);
  return baseCost / ((1 + discountRatePct / 100) ** yearsAfterStart);
};
